import { action, computed, makeObservable, onBecomeObserved } from "mobx"

import { catchErrors, subMerchantApi } from "@src/shared/api"
import Collection from "@src/shared/classes/Collection/Collection"
import { loading } from "@src/shared/classes/utils/loading"

export class SubMerchAccessRights extends loading(
  ["load"],
  Collection<string>,
) {
  constructor() {
    super()

    makeObservable(this, {
      load: action.bound,
      selectOptions: computed,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async load() {
    try {
      const {
        data: { data },
      } = await subMerchantApi.getSubmerchantsAccessGroups()

      if (data) {
        this.replace(data)
      }
    } catch (e: any) {
      catchErrors(e)
    }
  }

  get selectOptions() {
    return this.items.map((i) => ({
      label: i[0]?.toUpperCase() + i.slice(1),
      value: i,
    }))
  }
}
